import Authors from "../../authors"
import RenderCofabComponent from "../../../renderCofabComponent"
import GroupConv from "./groupConv"
import GroupConv2 from "./groupConv2"

export default class Detail extends Component {
  render() {
    const articleWidth = 700
    const Paragraph = ({ children, ...props }) => (
      <Text fontSize={17} lineHeight={1.5} marginY={10} {...props}>
        {children}
      </Text>
    )
    const Heading = ({ children, ...props }) => (
      <Surface
        width={articleWidth}
        marginBottom={20}
        paddingBottom={10}
        marginTop={20}
        borderBottom
      >
        <Text fontSize={24} lineHeight={1.5} {...props}>
          {children}
        </Text>
      </Surface>
    )

    return (
      <Surface width="100%" height="auto">
        <Surface
          width={"100%"}
          style={{
            borderBottom: "1px solid hsla(0, 0%, 0%, 0.1)",
          }}
          alignSelf="center"
          alignItems="center"
          marginTop={30}
          marginBottom={10}
          paddingBottom={10}
        >
          <Surface width={articleWidth}>
            <Authors />
          </Surface>
        </Surface>
        <Surface
          width={articleWidth}
          alignSelf="center"
          alignItems="flex-start"
        >
          <Heading>Group Conv</Heading>
        </Surface>
        <GroupConv />
        <Surface
          width={articleWidth}
          alignSelf="center"
          alignItems="flex-start"
        >
          <Paragraph>
            Rendering these rotationally invariant units with feature
            visualization, we can see that the model learned several types of
            curves.
          </Paragraph>
        </Surface>
        <RenderCofabComponent
          folder="curve-group-conv"
          component={GroupConv2}
        />

        <Surface
          width={articleWidth}
          alignSelf="center"
          alignItems="flex-start"
        >
          <Paragraph display="inline">
            We were surprised to find that the model learned group convolution
            being learned by the model without it being baked into the
            architecture. There is a long history of models finding{" "}
            <a href="https://arxiv.org/pdf/1803.03453.pdf">
              creative solutions
            </a>{" "}
            that researchers didn’t intend, but the analogous situation has not
            been demonstrated in the representations.
          </Paragraph>
          <Paragraph>
            Many of the biggest advances in machine learning — including
            convolutional neural networks — have been about imbuing models with
            useful priors. We believe this points towards a promising research
            direction of studying the representations of models with high
            degrees of freedom to discover positive ways to reduce this freedom.
          </Paragraph>
        </Surface>
      </Surface>
    )
  }
}
